// @ts-expect-error untyped import
import headerImageUrl from 'bender-url!ecosystem-marketplace-solutions-base/img/homepage-header-image.png';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { Image } from 'foundations-components/transitional/components/Image';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { StorefrontHeaderView } from 'marketplace-ui-common/storefront/components/StorefrontHeaderView';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function HeroSection({
  onShowFindPartnerWizard
}) {
  const {
    showImage
  } = useResponsiveProps({
    showImage: {
      sm: false,
      md: true
    }
  });
  return /*#__PURE__*/_jsx(StorefrontHeaderView, {
    color: "teal",
    gradientAngle: 194,
    children: /*#__PURE__*/_jsx(View, {
      marginInline: "auto",
      maxInlineSize: "1392px",
      paddingBlockStart: "1200",
      paddingInline: "800",
      children: /*#__PURE__*/_jsxs(Grid, {
        children: [/*#__PURE__*/_jsx(GridItem, {
          size: {
            sm: 12,
            md: 8
          },
          children: /*#__PURE__*/_jsxs(Flex, {
            alignItems: "start",
            flexDirection: "column",
            marginBlockEnd: "800",
            children: [/*#__PURE__*/_jsx(Text, {
              as: "h1",
              use: "on-dark",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "ecosystem-marketplace-solutions-ui.homepage.header.title"
              })
            }), /*#__PURE__*/_jsx(Text, {
              marginBlockStart: "400",
              use: "on-dark",
              typography: "body-200",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "ecosystem-marketplace-solutions-ui.homepage.header.subtitle"
              })
            }), /*#__PURE__*/_jsx(Button, {
              onClick: onShowFindPartnerWizard,
              use: "tertiary-light",
              marginBlockStart: "600",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "ecosystem-marketplace-solutions-ui.homepage.header.button"
              })
            })]
          })
        }), showImage && /*#__PURE__*/_jsx(GridItem, {
          size: 4,
          children: /*#__PURE__*/_jsx(Flex, {
            alignItems: "end",
            blockSize: "100%",
            marginInlineStart: "-1200",
            children: /*#__PURE__*/_jsx(Image, {
              maxBlockSize: "268px",
              maxInlineSize: "110%",
              responsive: false,
              src: headerImageUrl
            })
          })
        })]
      })
    })
  });
}